<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <v-alert v-if="booking_validation.message != ''">{{ booking_validation.message }}</v-alert>
                    <div class="d-flex justify-center">
                        <router-link class="sm-fullwidth" :to="{ name: 'Inscriptions' }">
                            <v-btn color="primary-dark" block class="sm-fullwidth mt-2" variant="default" size="small">
                                <v-icon icon="mdi-arrow-left-bold" class="mr-1"></v-icon> Retourner à l'étape précedente
                            </v-btn>
                        </router-link>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: ['booking_validation'],
    name: 'BookingNotValidAlert',
    data() {
        return {
            // Add your component data here
        };
    },
    methods: {
        // Add your component methods here
    },
};
</script>

<style scoped>
/* Add your component styles here */
</style>